import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/common';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/icons';
import '@grandvisionhq/elements';
import { UpsellItemContainer } from '../containers/UpsellItemContainer.js';
import '@grandvisionhq/api-client';

const UpsellProducts = ({ products  })=>/*#__PURE__*/ React.createElement("div", {
        className: "upsell"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "upsell__content"
    }, products.map((product)=>/*#__PURE__*/ React.createElement(UpsellItemContainer, swcHelpers.extends({
            key: product.sku
        }, product))
    )))
;

export { UpsellProducts };
//# sourceMappingURL=UpsellProducts.js.map
